// Incoming commands: Host => Module
export const UWM_INITIALIZE = 'UWM_INITIALIZE';
export const UWM_SET_EXPERIENCE_SCORE = 'UWM_SET_EXPERIENCE_SCORE';
export const UWM_THEME_CHANGE = 'UWM_THEME_CHANGE';
export const UWM_OPEN_MODAL = 'UWM_OPEN_MODAL';
export const UWM_TOKEN_CHANGE = 'UWM_TOKEN_CHANGE';
export const UWM_HOLDER_CONNECTED = 'UWM_HOLDER_CONNECTED';
export const UWM_CLOSE_POPUPS = 'UWM_CLOSE_POPUPS';
export const UWM_CLOSE_MODULE = 'UWM_CLOSE_MODULE';
export const UWM_LIVE_TOUR_TARGET = 'UWM_LIVE_TOUR_TARGET';

// Outgoing events: Module => Host (common protocol)
export const UWM_MODULE_LOADED = 'UWM_MODULE_LOADED';
export const UWM_MODULE_INITIALIZATION_ERROR = 'UWM_MODULE_INITIALIZATION_ERROR';
export const UWM_MODULE_RESIZE = 'UWM_MODULE_RESIZE';
export const UWM_MODULE_SCROLL = 'UWM_MODULE_SCROLL';
export const UWM_MODULE_SHOW_MENU = 'UWM_MODULE_SHOW_MENU';
export const UWM_MODULE_HIDE_MENU = 'UWM_MODULE_HIDE_MENU';
export const UWM_TRACK_ANALYTICS = 'UWM_TRACK_ANALYTICS';
export const UWM_NAVIGATE_TO = 'UWM_NAVIGATE_TO';
export const UWM_MODULE_DATA_RECEIVED_SUCCESS = 'UWM_MODULE_DATA_RECEIVED_SUCCESS';
export const UWM_MODULE_BACK_BUTTON_CLICK = 'UWM_MODULE_BACK_BUTTON_CLICK';
export const UWM_REFRESH_TOKEN = 'UWM_REFRESH_TOKEN';
export const UWM_SHOW_NOTIFICATION = 'UWM_SHOW_NOTIFICATION';
export const UWM_MODULE_LIVE_TOUR_TARGET = 'UWM_MODULE_LIVE_TOUR_TARGET';

// Feedback-specific outgoing events
export const UWM_MODULE_FEEDBACK_SUBMITTED = 'UWM_MODULE_FEEDBACK_SUBMITTED';
export const UWM_MODULE_FEEDBACK_SKIPPED = 'UWM_MODULE_FEEDBACK_SKIPPED';
export const UWM_MODULE_FEEDBACK_SUBMIT_ERROR = 'UWM_MODULE_FEEDBACK_SUBMIT_ERROR';
export const UWM_MODULE_FEEDBACK_CLOSED = 'UWM_MODULE_FEEDBACK_CLOSED';

// Insights-portal outgoing events
export const UWM_INSIGHT_CONSENT_ACCEPTED = 'UWM_INSIGHT_CONSENT_ACCEPTED';
export const UWM_LOYALTY_MILESTONE = 'UWM_LOYALTY_MILESTONE';
export const UWM_SET_PRESENTATION = 'UWM_SET_PRESENTATION';
export const UWM_INSIGHT_COLLAPSE = 'UWM_INSIGHT_COLLAPSE';
export const UWM_DETAILED_VIEW_STATE = 'UWM_DETAILED_VIEW_STATE';
export const UWM_OPTIMIZE_EXPERIENCE = 'UWM_OPTIMIZE_EXPERIENCE';
export const UWM_OPEN_INSIGHT_DETAIL = 'UWM_OPEN_INSIGHT_DETAIL';
export const UWM_OPEN_URL = 'UWM_OPEN_URL';
